// MOD-13 / REQ-42 — Topbar bildirim zili tipleri.
//
// Değerler BE `NotificationType` enum'u ile birebir (magic-string yok). BE her
// bildirimi kullanıcı-başı üretir; okuma/işaretleme yalnız kendi bildirimleri
// üzerinde çalışır (RBAC izni yok — herkes yalnız kendi bildirimini görür).

/** BE `NotificationType` — kapalı küme; yeni tür eklenirse hem burası hem BE güncellenir. */
export const NOTIFICATION_TYPES = [
  'WorkflowSubmitted',
  'WorkflowApproved',
  'WorkflowRejected',
  'WorkflowPublished',
  'FormSubmitted',
] as const;

export type NotificationType = (typeof NOTIFICATION_TYPES)[number];

/** Tek bir bildirim (deep-link = entityType + entityRef). */
export interface AppNotification {
  id: string;
  type: NotificationType;
  title: string;
  body: string | null;
  isRead: boolean;
  readAt: string | null;
  /** Deep-link ayırıcı: "Article" | "Page" | "Campaign" | "Sss" | "Form". */
  entityType: string;
  /** İçerik için slug (Article/Page/Campaign), SssItem/Form için id. */
  entityRef: string;
  createdAt: string;
}

/** Zil rozeti + dropdown listesi tek sorgudan beslenir: liste + tam okunmamış sayısı. */
export interface NotificationFeed {
  items: AppNotification[];
  unreadCount: number;
}

export interface NotificationListQuery {
  unreadOnly?: boolean;
  page?: number;
  pageSize?: number;
}
